import React from "react";
import { FormComponent } from "./FormComponent";
import { Control, FieldValues, useController } from "react-hook-form";

/* eslint @typescript-eslint/no-explicit-any: "off" */

type PhoneFieldProps<T extends FieldValues> = {
	control: Control<T>;
	id: string;
	inputClasses?: string;
	label: string;
	name: string;
	onInputChange?: (name: string, value: string) => void;
	placeholder?: string;
	required?: boolean;
};

export function PhoneField({
	control,
	id,
	inputClasses,
	name,
	label,
	onInputChange,
	placeholder,
	required = false,
}: PhoneFieldProps<any>) {
	const {
		field: { value, onChange },
		formState: { errors },
	} = useController({
		name,
		control,
		rules: {
			required,
		},
	});
	const component = { id, name, label, required, errors };

	const handleChange = (value: string) => {
		onInputChange && onInputChange(name, value);
		onChange(value);
	};

	return (
		<FormComponent {...component}>
			<input
				type="tel"
				className={inputClasses}
				onChange={(e) => handleChange(e.target.value)}
				id={id}
				placeholder={placeholder}
				value={value || ""}
			/>
		</FormComponent>
	);
}
